import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import pageNotFoundRoutes from "./views/page-not-found/page-not-found.routes";
import administrationRoutes from "./views/administration/administration.routes";
import pageNotAuthorizedRoutes from "./views/page-not-authorized/page-not-authorized.routes";

import maintenanceRoutes from "./views/maintenance/maintenance.routes";
import inventoryRoutes from "./views/Inventory/inventory.routes";

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    pageNotFoundRoutes,
    pageNotAuthorizedRoutes,
    ...administrationRoutes,
    ...maintenanceRoutes,
    ...inventoryRoutes,
  ]
});
